<template><div><h1 id="_4-dauerauftrage-alte-struktur-direkt-in-auftragen" tabindex="-1"><a class="header-anchor" href="#_4-dauerauftrage-alte-struktur-direkt-in-auftragen"><span>4. Daueraufträge (alte Struktur, direkt in Aufträgen)</span></a></h1>
<h2 id="_4-1-beschreibung" tabindex="-1"><a class="header-anchor" href="#_4-1-beschreibung"><span>4.1. Beschreibung</span></a></h2>
<p>Daueraufträge können folgendermassen charakterisiert werden:</p>
<ul>
<li>
<p>Die Parametrisierung eines Auftrags als Dauerauftrag erfolgt über die <RouteLink to="/referenz/refs/ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</RouteLink> , ein Dauerauftrag ist eine Auftragsart mit speziellen Eigenschaften.</p>
</li>
<li>
<p>Der Dauerauftrag ist eine REIHE von Aufträgen. Eine &quot;Reihe&quot; bedeutet, dass Wiederholungen des Auftrags parametrisiert werden können (automatische Verlängerung der Reihe ist implizit). Eine Reihe kann zu Ende geführt oder auch sofort abgebrochen werden.</p>
</li>
<li>
<p>Der Dauerauftrag enthält Informationen darüber, wie oft eine Reihe wiederholt werden soll (Standard = unbegrenzt, d.h. bis auf Widerruf des Kunden) und wie häufig innerhalb eines Jahres.</p>
</li>
<li>
<p>Bei jeder Fakturierung wird geprüft, ob die Reihe verlängert werden kann.</p>
</li>
<li>
<p>Bei jeder Fakturierung wird dann ein offener Auftrag im System eröffnet (sofern die obige Prüfung dies zulässt). Der neue, offene Auftrag erhält ein Verarbeitungsdatum, das abhängig von der Einstellung in der Auftragsart wie folgt berechnet wird:</p>
<table>
<thead>
<tr>
<th>Anzahl Lieferungen jährlich</th>
<th>Verarbeitungsdatum fakturiert (Beispiel)</th>
<th>Verarbeitungsdatum offener Auftrag</th>
</tr>
</thead>
<tbody>
<tr>
<td>12</td>
<td>28.2.00</td>
<td>plus 1 Monat</td>
</tr>
<tr>
<td>6</td>
<td>28.2.00</td>
<td>plus 2 Monate</td>
</tr>
<tr>
<td>4</td>
<td>28.2.00</td>
<td>plus 3 Monate</td>
</tr>
<tr>
<td>3</td>
<td>28.2.00</td>
<td>plus 4 Monate</td>
</tr>
<tr>
<td>2</td>
<td>28.2.00</td>
<td>plus 6 Monate</td>
</tr>
<tr>
<td>1</td>
<td>28.2.00</td>
<td>plus 12 Monate</td>
</tr>
</tbody>
</table>
</li>
</ul>
<p>Mit dem Festlegen des Verarbeitungsdatums im offenen Auftrag wird erreicht, dass der mit dem Kunden vereinbarte Rhythmus der Belieferung eingehalten wird.</p>
<ul>
<li>Über Veränderungen am Auftragsstatus kann der Benutzer das Verhalten des Systems im Einzelfall beeinflussen: er kann bestimmen, ob die Reihe abgeschlossen oder abgebrochen wird, bzw. nach einem Unterbruch wieder aufgenommen wird.</li>
</ul>
<h3 id="_4-1-1-anzeige-im-auftragsframe" tabindex="-1"><a class="header-anchor" href="#_4-1-1-anzeige-im-auftragsframe"><span>4.1.1. Anzeige im Auftragsframe</span></a></h3>
<p>Der Dauerauftrag zeichnet sich durch bestimmte Zusatzinformationen im Auftragskopf aus: Die Zeile [VaterAuf]. Sie zeigt:</p>
<ul>
<li>
<p>die Auftragsnummer des Urbelegs (des ersten erfassten Auftrags) (1155000)</p>
</li>
<li>
<p>die Anzahl der jährlichen Wiederholungen (6 = alle 2 Monate)</p>
</li>
<li>
<p>die Anzahl der ausgelieferten (=fakturierten) Aufträge in der laufenden Reihe (1 = erster Auftrag dieser aktuellen Reihe, es kann aber schon die 10. Reihe sein, d.h. der Ursprungsbeleg ist bereits ca. 10 Jahre alt, der Dauerauftrag läuft seit 10 Jahren)</p>
</li>
<li>
<p>den aktuellen Status des Dauerauftrags (0 = wird wiederholt bis auf Widerruf des Kunden)</p>
</li>
</ul>
<h2 id="_4-2-anderungen-am-dauerauftrag" tabindex="-1"><a class="header-anchor" href="#_4-2-anderungen-am-dauerauftrag"><span>4.2. Änderungen am Dauerauftrag</span></a></h2>
<p>Daueraufträge können Änderungen über die Zeit erfahren, sei es, dass der Kunde eine geringere Auftragsmenge wünscht, sei es, dass er neue / geänderte Artikel in den Auftrag nehmen will oder auch nur während der Ferien keine Lieferung erhalten. Damit einher gehen natürlich auch die entsprechenden Finanzbuchungen: Nachfakturierung bei Leistungsausweitung und vorausfakturierter Leistung; Guthaben auf dem Debitor bei verringerter Leistung; bzw. Berücksichtigung der Leistungsänderung bei nachträglicher Fakturierung.</p>
<p>Das Vorgehen ist dabei einfach: Der Benutzer ändert die &quot;Dauerauftragsbedingungen&quot;, indem er die Auftragspositionen den Kundenwünschen entsprechend anpasst, und zwar auf dem aktuell offenen Auftrag.</p>
<h3 id="_4-2-1-auftragsmenge" tabindex="-1"><a class="header-anchor" href="#_4-2-1-auftragsmenge"><span>4.2.1. Auftragsmenge</span></a></h3>
<p>Mit ändern wird die Menge in der Auftragsposition angepasst.</p>
<h4 id="_4-2-1-1-erhohung" tabindex="-1"><a class="header-anchor" href="#_4-2-1-1-erhohung"><span>4.2.1.1. Erhöhung</span></a></h4>
<p>Bei einer Erhöhung der Auftragsmenge reagiert das System wie folgt:</p>
<ul>
<li>
<p>Beim nächsten Fakturierungslauf wird die angepasste Menge im Auftrag übernommen</p>
</li>
<li>
<p>Das System berechnet die Differenz im Auftragsvolumen und druckt diese auf dem ESR aus, so dass der Kunde den Aufpreis bezahlen kann</p>
</li>
<li>
<p>Die neu gültige Auftragsmenge wird in den neuen offenen Auftrag kopiert</p>
</li>
</ul>
<h4 id="_4-2-1-2-verringerung" tabindex="-1"><a class="header-anchor" href="#_4-2-1-2-verringerung"><span>4.2.1.2. Verringerung</span></a></h4>
<p>Bei einer Verringerung der Auftragsmenge reagiert das System wie folgt:</p>
<ul>
<li>
<p>Die allenfalls zu viel bezahlte Leistung wird dem Kunden als Guthaben ausgewiesen und auf einer nächsten Rechnung in Abzug gebracht</p>
</li>
<li>
<p>Die neu gültige Auftragsmenge wird in den neuen offenen Auftrag kopiert</p>
</li>
</ul>
<h3 id="_4-2-2-auftragsposition-artikel" tabindex="-1"><a class="header-anchor" href="#_4-2-2-auftragsposition-artikel"><span>4.2.2. Auftragsposition (Artikel)</span></a></h3>
<p>Auch bei einer Änderung der Auftragsposition berücksichtigt das System bisherige</p>
<p>Zahlungsflüsse und reagiert analog wie oben dargestellt.</p>
<h3 id="_4-2-3-verarbeitungsdatum-im-auftragskopf" tabindex="-1"><a class="header-anchor" href="#_4-2-3-verarbeitungsdatum-im-auftragskopf"><span>4.2.3. Verarbeitungsdatum im Auftragskopf</span></a></h3>
<p>Der Kunde wünscht im Juli keine Lieferung, da er in den Ferien ist. Der Benutzer kann dazu im entsprechenden offenen Auftrag das Verarbeitungsdatum ändern, z.B. einen Monat nach hinten verschieben. Bei der nächsten Fakturierung im Juli wird dann der Auftrag nicht berücksichtigt, erst im August. Vorausgesetzt wird hier, dass die Fakturierung im Juni bereits gelaufen ist.</p>
<p>Die Reihe wird in diesem Fall zu Ende geführt, das heisst, ein monatlich auszuliefernder Auftrag wird 13 Monate dauern.</p>
<h2 id="_4-3-spezialitaten-im-dauerauftrag" tabindex="-1"><a class="header-anchor" href="#_4-3-spezialitaten-im-dauerauftrag"><span>4.3. Spezialitäten im Dauerauftrag</span></a></h2>
<h3 id="_4-3-1-mahnlauf" tabindex="-1"><a class="header-anchor" href="#_4-3-1-mahnlauf"><span>4.3.1. Mahnlauf</span></a></h3>
<p>Daueraufträge werden wie normale Aufträge im Mahnlauf berücksichtigt, sofern dies vom Benutzer gewünscht ist. Zur Spezifikation des Mahnlaufs siehe im Detail <RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="1. Debitorenverwaltung">Debitorenverwaltung</RouteLink> .</p>
<p>In der <RouteLink to="/referenz/refs/ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</RouteLink> wird gesteuert, ob ein Lieferstopp erfolgt wenn keine Zahlung zu eingegangen ist. Sobald ein Zahlungseingang erfolgt, wird die Auftragsreihe wieder aktiviert.</p>
<h3 id="_4-3-2-monatliche-fakturierung" tabindex="-1"><a class="header-anchor" href="#_4-3-2-monatliche-fakturierung"><span>4.3.2. Monatliche Fakturierung</span></a></h3>
<p>Die fakturierung wird mit dem Job <RouteLink to="/referenz/refs/ft.refdata.wbsjob.html" title="Fakturen/Avis aufbereiten">Fakturen/Avis aufbereiten</RouteLink> ausglöst.</p>
<p>Das Verarbeitungsdatum im Job muss unbedingt auf Ende des Monats gesetzt werden. Die Fakturierung kann im voraus geschehen. Es darf monatlich nur 1-mal fakturiert werden.</p>
</div></template>


